"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _string_utility = require("common-utilities/src/string_utility");

var _reactIntl = require("react-intl");

var _sanitize_utility = require("common-utilities/src/sanitize_utility");

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _card_component = require("./global_components/card_component");

var _card_component2 = _interopRequireDefault(_card_component);

var _functional_utility = require("common-utilities/src/functional_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundDefinitions = function (_React$PureComponent) {
  _inherits(FundDefinitions, _React$PureComponent);

  function FundDefinitions() {
    _classCallCheck(this, FundDefinitions);

    return _possibleConstructorReturn(this, (FundDefinitions.__proto__ || Object.getPrototypeOf(FundDefinitions)).apply(this, arguments));
  }

  _createClass(FundDefinitions, [{
    key: "render",
    value: function render() {
      var content = (0, _functional_utility.isNilOrEmpty)((0, _string_utility.getLocalizedString)(this.props.intl, "", 'pdp-definitions-content')) || (0, _string_utility.getLocalizedString)(this.props.intl, "", 'pdp-definitions-content') === 'pdp-definitions-content' ? '' : (0, _string_utility.getLocalizedString)(this.props.intl, "", 'pdp-definitions-content');
      return _react2.default.createElement(
        "div",
        { className: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12", "data-testid": "commentary-content" },
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: (0, _string_utility.renderFormattedLabel)("DEFINITIONS", "pdp-definitions-tab-label"),
            headerTitleId: "header-definitions" },
          _react2.default.createElement(
            "div",
            { className: "padding-top-10 font-book caption" },
            _react2.default.createElement("span", { "data-testid": "fund-definition-content", dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(content) } })
          )
        )
      );
    }
  }]);

  return FundDefinitions;
}(_react2.default.PureComponent);

exports.default = (0, _reactIntl.injectIntl)(FundDefinitions, { withRef: true });